import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { PlayIcon, HeadphonesIcon } from 'lucide-react';
const stories = [{
  name: 'María',
  age: 34,
  country: 'México',
  avatar: 'M',
  before: 'Tenía un trabajo estable pero sentía que estaba traicionando mi propósito. Miedo al dinero, miedo al fracaso.',
  process: 'Ruta Emprendedor + Mentoría 1:1 durante 6 meses',
  after: 'Lancé mi marca, generé $15,000 en el primer trimestre y por primera vez siento que mi trabajo y mi alma van en la misma dirección.',
  highlight: 'Mi trabajo y mi alma van en la misma dirección.',
  hasVideo: true
}, {
  name: 'Carlos',
  age: 41,
  country: 'Colombia',
  avatar: 'C',
  before: 'Tenía un negocio que funcionaba pero yo era el cuello de botella. Trabajaba 12 horas al día sin escalar.',
  process: 'Ruta Ecommerce + Programa Premium',
  after: 'Automaticé el 70% de mis operaciones. Mis ingresos crecieron 3x y recuperé mi tiempo y mi vida.',
  highlight: 'Mis ingresos crecieron 3x y recuperé mi vida.',
  hasAudio: true
}, {
  name: 'Valentina',
  age: 29,
  country: 'Argentina',
  avatar: 'V',
  before: 'Sabía que tenía algo que ofrecer pero no sabía cómo posicionarme. Me sentía invisible en mi industria.',
  process: 'Ruta Marca Personal + Alma en Expansión',
  after: 'Hoy tengo 50,000 seguidores, una comunidad activa y un negocio de conocimiento que genera mientras duermo.',
  highlight: 'Un negocio que genera mientras duermo.',
  hasVideo: true
}];
export function TransformationStories() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="historias" ref={ref} className="py-24 md:py-32 bg-cream" data-id="element-309">
      <div className="max-w-6xl mx-auto px-6" data-id="element-310">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-311">
          <p className="font-sans text-sm uppercase tracking-widest text-gold mb-4" data-id="element-312">
            Resultados reales
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-6" data-id="element-313">
            Historias de Transformación
          </h2>
          <p className="font-sans text-lg text-charcoal-mid font-light max-w-xl mx-auto" data-id="element-314">
            No son testimonios. Son vidas rediseñadas.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8" data-id="element-315">
          {stories.map((story, index) => <motion.div key={story.name} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.15,
          ease: 'easeOut'
        }} className="bg-white rounded-3xl p-8 shadow-sm" data-id="element-316">
              <div className="flex items-center gap-4 mb-6" data-id="element-317">
                <div className="w-14 h-14 rounded-full bg-gold/20 flex items-center justify-center" data-id="element-318">
                  <span className="font-serif text-xl text-gold" data-id="element-319">
                    {story.avatar}
                  </span>
                </div>
                <div data-id="element-320">
                  <h3 className="font-serif text-lg text-charcoal" data-id="element-321">
                    {story.name}, {story.age}
                  </h3>
                  <p className="font-sans text-sm text-charcoal-mid" data-id="element-322">
                    {story.country}
                  </p>
                </div>
                {story.hasVideo && <button className="ml-auto w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center hover:bg-gold/20 transition-colors" data-id="element-323">
                    <PlayIcon className="w-5 h-5 text-gold" data-id="element-324" />
                  </button>}
                {story.hasAudio && <button className="ml-auto w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center hover:bg-gold/20 transition-colors" data-id="element-325">
                    <HeadphonesIcon className="w-5 h-5 text-gold" data-id="element-326" />
                  </button>}
              </div>

              <div className="space-y-4" data-id="element-327">
                <div data-id="element-328">
                  <span className="font-sans text-xs uppercase tracking-wider text-charcoal-light" data-id="element-329">
                    Antes
                  </span>
                  <p className="font-sans text-sm text-charcoal-mid mt-1 leading-relaxed" data-id="element-330">
                    {story.before}
                  </p>
                </div>
                <div data-id="element-331">
                  <span className="font-sans text-xs uppercase tracking-wider text-charcoal-light" data-id="element-332">
                    Proceso
                  </span>
                  <p className="font-sans text-sm text-charcoal-mid mt-1" data-id="element-333">
                    {story.process}
                  </p>
                </div>
                <div data-id="element-334">
                  <span className="font-sans text-xs uppercase tracking-wider text-charcoal-light" data-id="element-335">
                    Después
                  </span>
                  <p className="font-sans text-sm text-charcoal-mid mt-1 leading-relaxed" data-id="element-336">
                    {story.after}
                  </p>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-beige" data-id="element-337">
                <p className="font-serif text-lg text-gold italic text-center" data-id="element-338">
                  "{story.highlight}"
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}